var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:(el) => { this.captchaRef = el },staticStyle:{"width":"304px","height":"78px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }